import { useNavigate } from 'react-router';

type AdministrativeItemProps = {
  name: string;
  Icon: React.FC;
  slug: string;
};

const AdministrativeItem = ({ name, Icon, slug }: AdministrativeItemProps) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(slug)}
      className="bg-[#EEF2F8] hover:bg-sky-100 rounded-[10px] flex items-center gap-4 px-8 py-4"
    >
      <Icon />
      <span className="text-primary-100 font-semibold text-lg">{name}</span>
    </button>
  );
};

export default AdministrativeItem;
